/**
 * Caps for the query-argument shape derivation. This walk is O(args) — a
 * handful of nodes even for an elaborate query — but the caps keep a
 * programmatically-built `include` tree from turning a log line into a page of
 * relation names.
 */
export const MAX_SHAPE_DEPTH = 12;
export const MAX_SHAPE_NODES = 256;

/** Relation paths carried on the log line, in traversal order. */
export const MAX_REPORTED_RELATIONS = 24;

/**
 * The only two argument keys this module is ever allowed to descend into.
 *
 * This is the PHI guarantee, expressed as an allowlist rather than a denylist:
 * `where`, `data`, `cursor`, `orderBy` and friends can hold patient values, so
 * they are never traversed and never read. Inside `include`/`select` the keys
 * are Prisma schema relation and field names, and only keys — never values —
 * leave this module.
 */
export const TRAVERSABLE_ARG_KEYS = ["include", "select"] as const;
